import { MailQuestion } from "@tamagui/lucide-icons";
import React from "react";
import { Linking } from "react-native";
import { View } from "tamagui";
import { useStores } from "../../core/stores";
import { Body } from "../../ui/Body";
import { Box } from "../../ui/Box";
import { Button } from "../../ui/Button";
import { Label } from "../../ui/Label";

export const BusinessDemoFooter = ({
  businessPlanUid,
}: {
  businessPlanUid: string;
}) => {
  const { businessPlansStore } = useStores();

  const businessPlan = businessPlansStore.byId.get(businessPlanUid);

  if (!businessPlan?.isDemo) {
    return null;
  }

  return (
    <View>
      <Box>
        <Label>🍿 Demo mode</Label>
        <Body muted>
          Take your time — explore the Tasks feature and understand how much
          value this brings to your groups when used as their central hub.
        </Body>
      </Box>
      <Button
        type="secondary"
        onPress={() => {
          Linking.openURL("mailto:hello@planira.app");
        }}
        icon={MailQuestion}
        iconPosition={"before"}
      >
        Questions? Reach out
      </Button>
    </View>
  );
};
